// extracted by css-extract-rspack-plugin
export default {"container":"uV78t7HUzkgolZoM","frame":"PzWSWagIAwwHNgRH"};